<script lang="ts" setup>
import { useExpenseTemp } from "@/store/expensesTemp";

const expenseTempStore = useExpenseTemp();
// props: {
//   ping: {
//     type: Number,
//     default: 0
//   },
// },
// watch: {
//   ping: {
//     handler () {
//       this.errorArr = this.handleErrorPing(this.items);
//     }
//   }
// },

const emit = defineEmits(["change"]);
const props = defineProps<{ ping: number }>();

const errorArr = ref([]);

const items = ref({
	reason: null,
	client: null,
	location: null, // ward
	category: null, // grade
	date: null,
	amount: null,
	file: null,
	description: null,
});

const listOfClients = computed(() => expenseTempStore.clientList);
const listOfReasons = computed(() => expenseTempStore.receiptTypes);
const location = ref<any>([]); // ward
const subcategory = ref<any>([]); // grade

// new
function formatWard(item, value) {
	console.log("shift.value.location)", value);
	setItem(item);
	location.value = items.value.client?.locations; // locations arr which references on wards
	subcategory.value = [];
	items.value.category = null;
	items.value.location = null;

	if (location.value?.length === 1) {
		const val = generatFromVal(0);
		inputWard(val);
	}
}

function inputWard(e, manualInput = false) {
	manualInput
		? (items.value.location = e)
		: (items.value.location =
				items.value.client?.locations[Number(e.target.value)]);
	items.value.category = null;
	formatGrade(); // category

	setItem("location");
}

function formatGrade() {
	subcategory.value = items.value.location?.subcategories; // subcategories arr which references on grades
	items.value.category = null;
	if (subcategory.value.length === 1) {
		const val = generatFromVal(0);
		inputGrade(val, false);
	}
}
function inputGrade(e: any, manualInput = false) {
	console.log("e", e);
	manualInput
		? (items.value.category = e)
		: (items.value.category =
				items.value.location?.subcategories[Number(e.target?.value)]);

	// if (manualInput) {
	// 	items.value.category =
	// 		items.value.location?.subcategories[Number(e.target?.value)];
	// }
	//  else {
	// items.value.category = e;
	// }

	setItem("category");
}

function generatFromVal(i) {
	return {
		target: {
			value: i,
		},
	};
}

async function init() {}
function setItem(item) {
	errorArr.value.includes(item) &&
		errorArr.value.splice(errorArr.value.indexOf(item), 1);
	// items.value[item] = value;
	// console.log(`${item}: `, value);
	emit("change", items.value);
}

watch(
	() => props.ping,
	() => {
		errorArr.value = expenseTempStore.handleErrorPing(items.value);
	},
);
onMounted(() => {
	init();
});

function addFiles(evt) {
	if (!evt?.hasFiles) return;
	for (const file of evt.files) {
		console.log(file);
		items.value.file = {
			name: file.name,
			file: file,
		};
		emit("change", items.value);
		errorArr.value.includes("file") &&
			errorArr.value.splice(errorArr.value.indexOf("file"), 1);
	}
}
</script>

<template>
	<div class="exp-form">
		<div class="group">
			<label class="label">Receipt reason*</label>
			<multiselect-form
				v-model="items.reason"
				:options="listOfReasons"
				label="name"
				placeholder="Choose reason"
				value-prop="id"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('reason') }"
				@select="setItem('reason')"
			/>
		</div>
		<div class="group">
			<label class="label">Client name*</label>
			<multiselect-form
				v-model="items.client"
				:options="listOfClients"
				label="name"
				placeholder="Choose client"
				value-prop="id"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('client') }"
				@select="formatWard('client', $event)"
			/>
		</div>

		<div class="group">
			<label class="label">Ward*</label>
			<multiselect-form
				v-model="items.location"
				:options="location"
				label="name"
				placeholder="Choose ward"
				value-prop="id"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('location') }"
				@select="inputWard($event, true)"
			/>
		</div>
		<div class="group">
			<label class="label">Grade*</label>
			<multiselect-form
				v-model="items.category"
				:options="subcategory"
				label="name"
				placeholder="Choose grade"
				value-prop="id"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('category') }"
				@select="inputGrade($event, true)"
			/>
		</div>

		<div class="group">
			<label class="label">Date of receipt*</label>
			<modern-date-picker
				v-model="items.date"
				placeholder="Select Date"
				:clearable="false"
				:enable-time-picker="false"
				format="dd/MM/yyyy"
				outputFormatString="YYYY-MM-DD "
				:class="{ error: errorArr.includes('date') }"
				@update:model-value="setItem('date')"
			/>
		</div>
		<div class="group">
			<modern-input
				ref="number"
				v-model="items.amount"
				label="Amount*"
				:bind="{
					placeholder: 'Input number...',
					class: { error: errorArr.includes('amount') },
					type: 'number',
					min: 0,
				}"
				@change="setItem('amount')"
			></modern-input>
		</div>

		<!-- <formElement
			@change="setItem('file', $event)"
			placeholder="Add picture.."
			title="Picture*"
			type="file"
			:errored="errorArr.includes('file')"
		/> -->
		<div class="group">
			<label class="label">Picture*</label>
			<!-- <file-dropzone
				:hideFileItems="true"
				@add="addFiles"
				@remove="removeFile"
				:error="errorArr.includes('file')"
			/> -->

			<div class="add-img">
				<file-picker
					:multiple="false"
					@change="addFiles"
				>
					<template #buttonLabel>Add picture..</template>
				</file-picker>
				<span
					v-if="errorArr.includes('file')"
					class="file-name errorTxt"
				>
					You must enter an receipt.
				</span>
				<span
					v-if="items.file && items.file.name"
					class="file-name"
				>
					{{ items.file?.name }}
				</span>
			</div>
		</div>

		<div class="group">
			<modern-input
				ref="number"
				v-model="items.description"
				label="Description"
				:bind="{
					placeholder: 'Input text...',
					class: { error: errorArr.includes('description') },
				}"
				type="text"
				:error="errorArr.includes('description')"
				@change="setItem('description')"
			></modern-input>
		</div>
	</div>
</template>
<style lang="scss">
.exp-form {
	.modern-input {
		padding-left: 0 !important;
	}
	label.label {
		color: $label-accent-color;
		font-size: 0.8rem;
		min-width: 100px;
		user-select: none;
	}
	.add-img {
		.file-name {
			margin-left: 30px;
		}
	}
	.error {
		border-color: $error-color !important;
	}
	.errorTxt {
		color: $error-color !important;
	}
}
</style>
